<template>
  <el-dialog
    top="50px"
    width="1000px"
    :title="item ? 'Sửa quyền hạn' : 'Thêm quyền hạn'"
    :visible="visible"
    :show-close="!callingAPI"
    append-to-body
    @close="$emit('close')"
  >
    <el-form
      ref="form"
      v-loading="loading"
      :model="form"
      :rules="rules"
      size="small"
    >
      <el-row
        label-position="top"
        type="flex"
        align="start"
        class="flex-wrap"
        :gutter="12"
      >
        <el-col
          :lg="4"
          :span="24"
        >
          <el-form-item
            prop="code"
            label="Mã quyền"
          >
            <el-input
              v-model="form.code"
              placeholder="Nhập mã quyền"
            />
          </el-form-item>
        </el-col>
        <el-col
          :lg="6"
          :span="24"
        >
          <el-form-item
            prop="name"
            label="Tên quyền"
          >
            <el-input
              v-model="form.name"
              placeholder="Nhập tên"
            />
          </el-form-item>
        </el-col>
        <el-col
          :lg="14"
          :span="24"
        >
          <el-form-item
            prop="description"
            label="Mô tả"
          >
            <el-input
              v-model="form.description"
              placeholder="Nhập mô tả"
            />
          </el-form-item>
        </el-col>
        <el-col
          :lg="24"
          :span="24"
        >
          <el-form-item
            label="Danh sách hành động"
            style="margin: 0;"
          >
            <div style="width: 100%; text-align: end;">
              <el-checkbox
                v-model="form.allow_all"
              >
                Được phép sử dụng toàn bộ hành động
              </el-checkbox>
            </div>
            <el-row
              :key="JSON.stringify(form.actions)"
              type="flex"
              class="flex-wrap w-100"
              justify="space-between"
              :gutter="12"
            >
              <el-col
                v-for="(action, index) in allActions"
                :key="index"
                :lg="6"
                :span="6"
                class="mt-m"
              >
                <el-card
                  size="small"
                  shadow="never"
                  class="permission-card w-100 h-100"
                >
                  <div slot="header">
                    <el-checkbox
                      :value="form.allow_all || Object.keys(form.actions[action.key] || {}).length === actionMethods.length"
                      @change="(v) => handleChangeAction(action, v)"
                    >
                      <b>{{ action.label }}</b>
                    </el-checkbox>
                  </div>
                  <el-row
                    :gutter="8"
                  >
                    <el-col
                      v-for="method in actionMethods.filter((m) => action.methods ? action.methods.includes(m.key) : m)"
                      :key="method.key"
                      :span="12"
                    >
                      <el-checkbox
                        :label="method.key"
                        :value="form.allow_all || Object.keys((form.actions[action.key] || {})).includes(method.key)"
                        style="width: 100%; margin-right: 0;"
                        @change="(v) => handleChangeMethod(action, method, v)"
                      >{{ method.label }}</el-checkbox>
                    </el-col>
                  </el-row>
                </el-card>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        :disabled="callingAPI"
        size="medium"
        @click="$emit('close')"
        >Đóng</el-button
      >
      <el-button
        type="primary"
        :loading="callingAPI"
        size="medium"
        @click="handleConfirm"
        >Lưu</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { notification } from "@/utils/common";
import roleServices from "@/services/role";
import CONSTANTS from "@/config/constants";
import dayjs from "dayjs";

export default {
  name: "DataFormPopup",
  props: {
    item: Object,
    visible: Boolean,
    orgInfo: Object,
  },
  data() {
    return {
      loading: false,
      form: {
        code: "",
        name: "",
        description: "",
        allow_all: false,
        actions: {}
      },
      callingAPI: false,
      actionMethods: CONSTANTS.DOCUMENT_TYPE_ACTION_METHODS
    };
  },
  computed: {
    isCreate() {
      return !this.item || !this.item.id;
    },
    allActions() {
      return CONSTANTS.DOCUMENT_TYPE_ACTIONS.filter((c) => !c.coming_soon)
    },
    payloadData() {
      const payload = {
        code: this.form.code,
        name: this.form.name,
        summary: this.form.name,
        description: this.form.description,
        extra: {},
        translation_extra: "",
        allow_all: this.form.allow_all,
        document_type_actions: this.form.allow_all ? undefined : this.form.actions,
        type: this.item ? this.item.type || "" : "",
        creator_id: this.item ? this.item.creator_id || "" : "",
        register_at: this.item ? this.item.register_at || dayjs() : dayjs(),
        tag_ids: this.item ? this.item.tag_ids || [] : [],
        status: this.item ? this.item.status || "" : "",
        ordered: this.item ? this.item.ordered || 0 : 0,
        avatar_url: this.item ? this.item.avatar_url || "" : "",
        organization_id: this.orgInfo.id,
      };
      if (this.item) {
        payload['id'] = this.item.id
      }
      return payload
    },
    rules() {
      const result = {
        code: [
          {
            required: true,
            message: `Mã là trường bắt buộc.`,
            trigger: ["blur", "change"],
          },
        ],
        name: [
          {
            required: true,
            message: `Tên là trường bắt buộc.`,
            trigger: ["blur", "change"],
          },
        ]
      };
      return result;
    },
  },
  beforeMount() {
    this.loadFormData();
  },
  methods: {
    loadFormData() {
      if (this.item) {
        this.form = {
          code: this.item.code,
          name: this.item.translations?.vi?.name || "",
          description: this.item.translations?.vi?.description || "",
          allow_all: this.item.allow_all,
          actions: JSON.parse(JSON.stringify(this.item.document_type_actions || {}))
        };
      } else {
        this.form = {
          code: "",
          name: "",
          description: "",
          allow_all: false,
          actions: {}
        };
      }
    },
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.callingAPI = true;
          roleServices[!this.isCreate ? "update" : "create"](
            this.payloadData
          )
            .then(() => {
              this.callingAPI = false;
              this.$emit("reload");
              notification(
                this,
                "success",
                !this.isCreate ? "update" : "create",
                "quyền hạn"
              );
              this.$emit("close");
            })
            .catch(() => {
              this.callingAPI = false;
              notification(
                this,
                "error",
                !this.isCreate ? "update" : "create",
                "quyền hạn"
              );
            });
        }
      });
    },
    handleChangeAction(action, v) {
      const newAction = {}
      if (v) {
        this.actionMethods.forEach((m) => {
          newAction[m.key] = { allowed: true }
        })
      }
      const newActions = JSON.parse(JSON.stringify(this.form.actions));
      if (Object.keys(newAction).length > 0) {
        newActions[action.key] = newAction;
      } else {
        delete newActions[action.key]
      }
      this.form.actions = JSON.parse(JSON.stringify(newActions))
    },
    handleChangeMethod(action, method, v) {
      const newActions = JSON.parse(JSON.stringify(this.form.actions));
      if (newActions[action.key] && newActions[action.key][method.key]) {
        delete newActions[action.key][method.key]
      } else {
        newActions[action.key] = {
          ...newActions[action.key],
          [method.key]: {
            allowed: true
          }
        }
      }
      this.form.actions = JSON.parse(JSON.stringify(newActions))
    }
  },
};
</script>

<style lang="scss">
.permission-card {
  .el-card__header {
    padding: 0px 16px;
  }
  .el-card__body {
    padding: 0px 16px;
  }
}
</style>
